import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ChevronsRight = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 24'
    >
      <path
        fill='transparent'
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M6.0625 17L11.0625 12L6.0625 7M13.0625 17L18.0625 12L13.0625 7'
      />
    </svg>
  );
};
